export const createTitleTags = ({
  current_category_data,
  current_cat_id,
  main_place_of_delivery,
  TitelOnline,
  bi_platform,
  ZoneOfRequest,
}) => {
  const display_title = TitelOnline.trim()

  // code: r001 / Number 4 translates to: "Dienstleistung"
  // code: r004 / Number 4 translates to: "Sonstiges"
  // code: r002 / Number 2 translates to: "Lieferleistung"
  // code: r003 / Number 1 translates to: "Bauleistung"

  const root_service_types_by_category = {
    r001: 4,
    r002: 2,
    r003: 1,
    r004: 4,
  }
  const root_service_type =
    root_service_types_by_category[current_cat_id.slice(0, 4)]

  const title_tag_templates = {
    1: `${ZoneOfRequest === 4 ? "Auftrag" : "Ausschreibung"} ${
      current_category_data?.seo_name || ""
    } in ${main_place_of_delivery}: ${display_title}`,
    2: `${ZoneOfRequest === 4 ? "Auftrag" : "Ausschreibung"} Lieferleistung ${
      current_cat_id.length > 4 ? current_category_data?.seo_name : ""
    } in ${main_place_of_delivery}: ${display_title}`,
    4: `${display_title} in ${main_place_of_delivery}`,
  }
  const h1_template = {
    1: `Ausschreibung ${
      current_category_data?.seo_name || ""
    } in ${main_place_of_delivery}`,
    2: `Ausschreibung Lieferleistung ${
      current_cat_id.length > 4 ? current_category_data?.seo_name : ""
    } in ${main_place_of_delivery}`,
    4: `${!bi_platform ? "Öffentliche" : ""} Ausschreibung in ${main_place_of_delivery}`,
  }
  return [
    title_tag_templates[root_service_type],
    h1_template[root_service_type],
  ]
}
